import React, { useState } from "react";

import DropZone from "../../uploader/dropZone";
import FileCard from "./fileCard";

import "./style.css";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { acceptedDocuments } from "../../../constants/acceptedDocuments";
import { displayErrorToast } from "../../../store/actions/overflowNotification";
import { FormattedMessage, useIntl } from "react-intl";

const Uploader = props => {
  const {
    filesFromValues,
    numQuestion,
    onUpload,
    required,
    questionDesc
  } = props;
  const answerDetail = useSelector(state => state.ask.answer.detail);
  const [filesArr, setFilesArr] = useState({});
  const [existingFiles, setExistingFiles] = useState({});
  const [uploadError, setUploadError] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    onUpload(filesArr);
  }, [filesArr]);

  useEffect(() => {
    if (answerDetail.items) {
      if (answerDetail.items[numQuestion - 1].value) {
        setFilesArr({
          ...filesArr,
          [numQuestion]: answerDetail.items[numQuestion - 1].value
        });
        setExistingFiles({
          ...existingFiles,
          [numQuestion]: answerDetail.items[numQuestion - 1].value
        });
      }
    }
  }, [answerDetail.items]);

  useEffect(() => {
    setFilesArr({
      ...filesArr,
      [numQuestion]: filesFromValues
    });
  }, [numQuestion]);

  useEffect(() => {
    if (answerDetail.items) {
      setExistingFiles({
        ...existingFiles,
        [numQuestion]: answerDetail.items[numQuestion - 1].value
      });
    }
  }, [numQuestion]);

  useEffect(() => {
    if (uploadError) {
      dispatch(displayErrorToast(<FormattedMessage id={"ask.pages.answer.uploadHint"} />));
    }
  }, [uploadError]);

  const uploadHint = useIntl().formatMessage({ id: "ask.pages.answer.uploadHint" });

  const checkFileType = fileContent => {
    let check = false;
    for (let it in acceptedDocuments) {
      let item = acceptedDocuments[it];
      if (fileContent.indexOf(item.mime) > -1) {
        check = true;
      }
    }
    return check;
  };

  const checkSize = fileContent => {
    let check = false;
    let byteLength = parseInt(fileContent.replace(/=/g, "").length * 0.75);
    if (byteLength <= 16777216) {
      check = true;
    }
    return check;
  };

  const handleUpload = filesList => {
    let files = filesList.target ? filesList.target.files : filesList;
    let infoFile = [...filesArr[numQuestion]];
    setUploadError(false);
    for (let f = 0; f < files.length; f++) {
      const filereader = new FileReader();
      filereader.readAsDataURL(files[f]);
      filereader.onloadend = evt => {
        // Controllo se file è di tipo XML, P7M, PDF, JPEG, JPG, PNG, DOC, DOCX, XLS, XLSX, CSV
        if (
          checkFileType(filereader.result.substr(0, 100)) &&
          checkSize(filereader.result)
        ) {
          if (
            evt.target.readyState === FileReader.DONE &&
            !infoFile.find(x => x.fileName === files[f].name)
          ) {
            infoFile.push({
              fileName: files[f].name,
              // size: files[f].size,
              content: filereader.result
            });
            if (f === files.length - 1)
              setFilesArr({ ...filesArr, [numQuestion]: infoFile });
          }
        } else {
          setUploadError(true);
        }
      };

      // const blob = files[f].slice(0, 4);
      // filereader.readAsArrayBuffer(blob);
    }
  };

  const handleRemove = removedFile => {
    let cloneFilesList = [...filesArr[numQuestion]];
    cloneFilesList = cloneFilesList.filter(el => {
      return el.fileName !== removedFile.fileName;
    });
    setFilesArr({ ...filesArr, [numQuestion]: cloneFilesList });
  };

  return (
    <div className="contentStep">
      <div className="contentQuestionBold">
        {questionDesc} {required ? "*" : ""}
      </div>
      <div className="suggestions">
        {uploadHint}
      </div>
      <DropZone handleDrop={handleUpload} />
      <div>
        {filesArr[numQuestion] &&
          filesArr[numQuestion].map(el => {
            return (
              <FileCard
                showRemove={
                  !existingFiles[numQuestion] ||
                  (existingFiles[numQuestion] &&
                    !existingFiles[numQuestion].find(x => x.fileName === el.fileName))
                }
                key={el.fileName}
                file={el}
                handleRemove={handleRemove}
              />
            );
          })}
      </div>
    </div>
  );
};

export default Uploader;
